var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"clock"},[_c('span',[_vm._v(_vm._s(_vm.hours))]),_vm._v("点"),_c('span',[_vm._v(_vm._s(_vm.mins))]),_vm._v("分"),_c('span',[_vm._v(_vm._s(_vm.secs))]),_vm._v("秒\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }